<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="100px"
      label-position="right">
      <el-form-item label="项目名称" prop="projectId">
        <el-select v-model="formData.projectId" placeholder="请选择所属项目" filterable @change="projectChange">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班组名称" prop="teamId">
        <el-select v-model="formData.teamId" :disabled="!formData.projectId" placeholder="请选择班组" filterable>
          <el-option v-for="(item, index) of teamList" :key="index" :label="item.teamName"
            :value="item.teamId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="startDate" label="开始日期">
        <el-date-picker v-model="formData.startDate" value-format="yyyy-MM-dd" type="date"
          placeholder="请选择开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item prop="endDate" label="结束日期">
        <el-date-picker v-model="formData.endDate" value-format="yyyy-MM-dd" type="date"
          placeholder="请选择结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item prop="contractAmount" label="合同总额">
        <el-input v-model="formData.contractAmount" placeholder="请输入合同总额"></el-input>
      </el-form-item>
      <el-form-item prop="minWorkerNum" label="最低用工数">
        <el-input v-model="formData.minWorkerNum" placeholder="请输入最低用工数"></el-input>
        人/
        <el-select class="minWorkerType" v-model="formData.minWorkerType" placeholder="请选择最低用工类型">
          <el-option value="1" label="天"></el-option>
          <el-option value="2" label="月"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="fileList" label="合同文件">
        <file-upload v-model="formData.fileList" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import FileUpload from '@/components/FileUpload.vue'
export default {
  name: 'add',
  components: {
    FileUpload
  },
  data() {
    return {
      teamList: [],
      formData: {
        teamId: '', // 班组ID
        projectId: '', // 项目ID
        startDate: '', // 劳务开始日期
        endDate: '', // 劳务结束日期
        contractAmount: '', // 合同金额
        minWorkerType: '1', // 最低用工类型1天2月
        minWorkerNum: '', // 最低用工数
        fileList: [] // 附件列表
      },
      rules: {
        projectId: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        teamId: [
          { required: true, message: '请选择班组名称', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'blur' }
        ],
        contractAmount: [
          { required: true, message: '请输入合同总额', trigger: 'blur' }
        ],
        minWorkerNum: [
          { required: true, message: '请输入最低用工数', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    },
    teamLaborId() {
      return this.$route.query.teamLaborId
    }
  },
  watch: {
  },
  created() {
    if (this.teamLaborId) {
      this.loadData()
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.laborManage.selectTeamLaborByTeamLaborId, {
        teamLaborId: this.teamLaborId
      }).then(res => {
        this.formData = res || {}
        this.loadTeamList(res.projectId)
      })
    },
    projectChange(val) {
      this.formData.teamId = ''
      this.loadTeamList(val)
    },
    loadTeamList(projectId) {
      this.$axios.get(this.$apis.laborManage.selectYhTeamByList, {
        projectId,
        laborModel: '1'
      }).then(res => {
        this.teamList = res || []
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.teamLaborId ? this.$apis.laborManage.updateTeamLabor : this.$apis.laborManage.insertTeamLabor
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.minWorkerType {
  width: 60px !important;

  ::v-deep {
    .el-input {
      width: 60px !important;
    }
  }
}
</style>
